import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/hooks/useAuth'
import { AlunoRepository } from '@/pages/admin/repositories/aluno.repository'

interface IProps {
  page: number
  perPage: number
  property?: string
  value?: string
}

export const useListStudents = ({ page, perPage, property, value }: IProps) => {
  const { token } = useAuth()
  const listStudents = () =>
    value
      ? AlunoRepository.GetInstance().findByProperty({
          token,
          page,
          perPage,
          property,
          value,
        })
      : AlunoRepository.GetInstance().list(token, { page, perPage })

  const queryKey = [
    `list_students?${property}=${value}&page=${page}&perPage=${perPage}`,
  ]

  const { isPending, data, error } = useQuery({
    queryKey,
    queryFn: listStudents,
  })

  const students = data?.data || data?.students || []

  return {
    isPending,
    students,
    count: data?.count || 0,
    error,
  }
}
